import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';
import { useTranslation } from '@hooks/index';

type RecordProps = {
    id?: number;
    description: string;
    OwnerName?: string;
    CompletedDate?: string;
    Status?: string;
    RequestedDate?: string;
    Description?: string;
    DueDate?: string;
    Resolution?: string;
    Comments?: string;
    SiteName?: string;
    IntegrationEnabled: number;
    IntegrationUpdated?: {
        $date?: string;
    };
};

type ObservationChangeGridProps = {
    oldRecord: Partial<RecordProps>;
    newRecord: Partial<RecordProps>;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
};

const CM2ActionRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: ObservationChangeGridProps) => {
    const propArray = [
        'CompletedDatePopulatedOn',
        'IsDeleted',
        'Owner',
        'OwnerId',
        'OwnerName',
        'ResponsibleFunction',
        'SiteName',
        'ControlReviewLogId',
        'StudyReviewLogId',
        'SiteReviewLogId',
        'IntegrationStatus',
    ];

    const { t } = useTranslation();

    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
        Owner: oldRecord?.OwnerName,
        Site: oldRecord?.SiteName,
        Status: oldRecord?.Status === 'Closed' ? t('auditLog:Completed') : oldRecord?.Status,
        IntegrationEnabled:
            oldRecord.IntegrationEnabled == null
                ? undefined
                : oldRecord.IntegrationEnabled === 0
                  ? t('common:no')
                  : t('common:yes'),
    } as Record<string, unknown>;

    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
        Owner: newRecord?.OwnerName,
        Site: newRecord?.SiteName,
        Status: newRecord?.Status === 'Closed' ? t('auditLog:Completed') : newRecord?.Status,
        IntegrationEnabled:
            newRecord.IntegrationEnabled == null
                ? undefined
                : newRecord.IntegrationEnabled === 0
                  ? t('common:no')
                  : t('common:yes'),
    } as Record<string, unknown>;

    const items = getFieldChangeItems(
        refactoredOldRecord,
        refactoredNewRecord,
        null,
        (field: string) =>
            getProcessedFieldChangeItems({
                oldRecord: refactoredOldRecord,
                newRecord: refactoredNewRecord,
                oldItem,
                newItem,
                field,
            }),
        ['IntegrationUpdated'],
    );

    return <FieldChangeGrid items={items} />;
};

export { CM2ActionRecordChangeGrid };
